import styled from "styled-components";
import Colors from "../../themes/Colors";

const CART_PADDING = "20px";

const CartHolder = styled.div`
  .cartButton {
    position: fixed;
    z-index: 996;
    top: 10px;
    right: 30px;
    height: auto;
    padding: 8px 15px;
    width: 210px;
    border-radius: 8px;
    background-color: ${Colors.primary};
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 4px;

    font-size: 16px;
    font-weight: 600;

    @media only screen and (max-width: 576px) {
      margin-top: 10px;
      position: revert;
      margin-left: 10px;
      margin-bottom: 5px;
    }

    @media only screen and (min-width: 576px) {
      top: calc(75px + 127px + 50px);
    }

    @media only screen and (min-width: 1000px) {
      top: calc(170px + 77px + 12px);
    }
  }
  .cartNextButton {
    display: block;
    position: fixed;
    z-index: 996;
    bottom: 15px;
    right: 15px;
    height: 65px;
    background-color: ${Colors.primary};
    font-size: 16px;
    font-weight: 600;
  }
  .cartNextButtonHidden {
    display: none;
  }
  .cartButtonHidden {
    position: fixed;
    z-index: 2;
    top: calc(50% - 25px);
    right: -150px;
    height: 45px;
    width: 150px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    background-color: ${Colors.primary};

    font-size: 16px;
    font-weight: 600;

    @media only screen and (min-width: 768px) {
      top: calc(85px + 127px + 70px);
    }

    @media only screen and (min-width: 1000px) {
      top: calc(85px + 77px + 12px);
    }
  }

  .ant-badge-count {
    background-color: ${Colors.secondary};
    box-shadow: none;
    right: unset;
    left: -5px;
    top: unset;
    bottom: -8px;
  }

  .disabledCart {
    pointer-events: none;
    opacity: 0.4;
  }
  .cartDrawer {
    padding: 10px !important;
    box-shadow: none !important;
  }
  .currencyExchangeButton {
    background-color: transparent;
    color: ${Colors.white};
    border: none;
  }
`;

/* Redesigned cart drawer content (LATIN-2537).
   The Ant Drawer portals its body to <body>, outside CartHolder's scoped class,
   so the drawer styles must live in their own styled wrapper that IS the root
   of the drawer content — otherwise the scoped selectors never match. */
export const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: ${Colors.snow};

  .cartHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px ${CART_PADDING} 12px;
    border-bottom: 1px solid ${Colors.border};
    margin-bottom: 8px;
  }
  .cartHeaderTitle {
    font-size: 18px;
    font-weight: 600;
    color: ${Colors.coal};
  }
  .cartHeaderTitle .count {
    color: ${Colors.primaryAccent};
  }
  .cartClose {
    font-size: 18px;
    color: ${Colors.grayMedium};
    cursor: pointer;
  }
  .cartBody {
    display: flex;
    flex: 1;
    min-height: 0;
  }
  .cartListColumn {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;
    border-right: 1px solid ${Colors.border};
  }
  .cartInfoColumn {
    width: 450px;
    flex-shrink: 0;
    overflow-y: auto;
    padding: 0 ${CART_PADDING} 16px ${CART_PADDING};
    display: flex;
    flex-direction: column;
  }
  @media only screen and (max-width: 767px) {
    .cartBody {
      flex-direction: column;
    }
    .cartListColumn {
      border-right: none;
      border-bottom: 1px solid ${Colors.border};
    }
    .cartInfoColumn {
      width: 100%;
    }
  }
  .cartScreenList {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    padding: 0 ${CART_PADDING};
    /* Subtle, thin scrollbar */
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
  }
  .cartScreenList::-webkit-scrollbar {
    width: 5px;
  }
  .cartScreenList::-webkit-scrollbar-track {
    background: transparent;
  }
  .cartScreenList::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 8px;
  }
  .cartScreenList:hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.28);
  }
  .cartEmpty {
    color: ${Colors.grayMedium};
    padding: 16px 0;
  }
  .cartScreenRow {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
  .cartScreenRow:last-child {
    border-bottom: none;
  }
  .cartRowThumb {
    width: 56px;
    height: 44px;
    object-fit: cover;
    border-radius: 6px;
    flex-shrink: 0;
  }
  .cartRowInfo {
    flex: 1;
    min-width: 0;
  }
  .cartRowNameLine {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .cartRowNameLine .doubleScreen,
  .cartRowNameLine .screenCardCircuitButton {
    background-color: ${Colors.primary};
    border-color: ${Colors.primary};
    color: ${Colors.white};
    margin-left: 0;
    flex-shrink: 0;
  }
  .cartRowNameLine .screenCardSyncCircuitWrapper {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
  }
  .cartRowNameLine .cartRowBundleButton {
    background-color: ${Colors.snow};
    border-color: ${Colors.primaryAccent};
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .cartRowNameLine .cartRowBundleIcon svg {
    width: 16px;
    height: 16px;
  }
  .cartRowName {
    font-weight: 600;
    color: ${Colors.coal};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .cartRowLocation {
    font-size: 12px;
    color: ${Colors.grayMedium};
    margin-bottom: 4px;
  }
  .cartRowMeta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }
  .cartRowMeta .ant-tag {
    margin-right: 0;
  }
  .cartRowFormatTag {
    min-width: 68px;
    text-align: center;
  }
  .cartRowPrice {
    color: ${Colors.primaryAccent};
    font-weight: 600;
    font-size: 13px;
  }
  .cartRowRemove {
    color: ${Colors.grayMedium};
    cursor: pointer;
    font-size: 14px;
    flex-shrink: 0;
    align-self: flex-start;
  }
  .audienceCard {
    background: ${Colors.extraLightPrimary};
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 10px;
  }
  .audienceCardTitle {
    color: ${Colors.primaryAccent};
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 10px;
  }
  .audienceStatRow {
    display: flex;
    gap: 10px;
  }
  .audienceStat {
    background: ${Colors.snow};
    border-radius: 8px;
    padding: 8px 12px;
    flex: 1;
    min-width: 0;
  }
  .audienceStatValue {
    font-size: 20px;
    font-weight: 700;
    color: ${Colors.coal};
    line-height: 1.2;
  }
  .audienceStatLabel {
    font-size: 12px;
    color: ${Colors.grayMedium};
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .audienceBreakdown {
    display: flex;
    justify-content: space-around;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    margin-top: 10px;
    padding-top: 10px;
    text-align: center;
  }
  .audienceBreakdownItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
  }
  .audienceBreakdownItem .anticon {
    color: ${Colors.primaryAccent};
    font-size: 16px;
  }
  .audienceBreakdownItem .value {
    font-weight: 700;
    color: ${Colors.coal};
  }
  .audienceBreakdownItem .label {
    font-size: 11px;
    color: ${Colors.grayMedium};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
  }
  .audienceBreakdownItem .label .anticon {
    font-size: 1em;
  }
  .screensSummary {
    display: flex;
    gap: 8px;
    margin-bottom: 10px;
  }
  .screensSummaryItem {
    background: ${Colors.snow};
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 10px 6px;
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    text-align: center;
  }
  .screensSummaryItem .anticon,
  .screensSummaryItem svg {
    color: ${Colors.primaryAccent};
    font-size: 16px;
  }
  .screensSummaryItem .value {
    font-weight: 700;
    font-size: 18px;
    color: ${Colors.coal};
    line-height: 1.2;
  }
  .screensSummaryItem .label {
    font-size: 11px;
    color: ${Colors.grayMedium};
    line-height: 1.2;
  }
  /* Same card treatment as .selectedScreensCount / .screensSummaryItem. */
  .budgetCard {
    background: ${Colors.snow};
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 8px;
    text-align: center;
  }
  .budgetCardLabel {
    font-size: 13px;
    color: ${Colors.grayMedium};
  }
  .budgetCardValue {
    font-size: 28px;
    font-weight: 700;
    color: ${Colors.primaryAccent};
    line-height: 1.2;
  }
  /* Same card treatment as the .screensSummaryItem tiles below it. */
  .selectedScreensCount {
    background: ${Colors.snow};
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 10px 6px;
    margin-bottom: 8px;
    text-align: center;
    font-size: 15px;
    font-weight: 700;
    color: ${Colors.coal};
  }
  .selectedScreensCount .count {
    font-weight: 700;
    color: ${Colors.primaryAccent};
  }
  .budgetCardCpm {
    font-size: 12px;
    color: ${Colors.grayMedium};
  }
  .budgetMinWarning {
    color: ${Colors.red};
    font-size: 11px;
    margin-top: 4px;
  }
  .cartActions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    /* Keeps the buttons pinned to the bottom of the column (the budget card
       used to do this before it moved to the top). */
    margin-top: auto;
    padding-top: 12px;
  }
  .cartActions .ant-btn {
    height: 42px;
    border-radius: 8px;
    font-weight: 600;
    width: 100%;
  }
  .outlineBlueButton,
  .outlineBlueButton:hover,
  .outlineBlueButton:focus {
    color: ${Colors.primaryAccent};
    border-color: ${Colors.primaryAccent};
  }
  .deleteSelectionButton {
    color: ${Colors.red};
    border-color: ${Colors.borderStrong};
    background: ${Colors.snow};
  }
`;

export default CartHolder;
